export class BaseModel {
  id: string;
  creation: number;
  version: number;
  lastUpdated: number;
}
